'use client'

// SUMMARY: Lets an in-chat document-wizard <DocumentForm> (rendered deep inside react-markdown) submit the
// user's answers back into the chat without threading props through the markdown renderer. The chat page
// provides `onSubmit` (which calls chat.send with the formatted answers) + a `disabled` flag.

import { createContext, useContext } from 'react'

export interface DocumentFormActions {
	/** Send the user's filled-in answers as a chat message (continues the wizard → generation). */
	onSubmit: (text: string) => void
	/** Disable the form while a turn is streaming. */
	disabled: boolean
}

const DocumentFormContext = createContext<DocumentFormActions | null>(null)

export function DocumentFormProvider({ value, children }: { value: DocumentFormActions; children: React.ReactNode }) {
	return <DocumentFormContext.Provider value={value}>{children}</DocumentFormContext.Provider>
}

export function useDocumentFormActions(): DocumentFormActions | null {
	return useContext(DocumentFormContext)
}
